import { PiralInstance } from "piral-core";
import BlazorIntegrator from "./blazor";
import SignOutCallback from "./pages/SignOutCallback";
import * as React from 'react'
import HomeMenu from "./components/HomeMenu";
import AboutMenu from "./components/AboutMenu";
import ServiceWorkerRegistration from "./ServiceWorkerRegistration";
import SettingsAccessibility from "./components/SettingsAccessibility";
import SearchMenu from "./components/SearchMenu";
import UserSettingsMenu from "./components/UserSettingsMenu";
import SettingsMenu from "./components/SettingsMenu";
import SystemSettingsMenu from "./components/SystemSettingsMenu";
import SignInCallback from "./pages/SignInCallback";

export function startup(instance: PiralInstance) {
    const approot = instance.root;

    // Get the appsettings    
    let appsettings = approot.getData('appsettings');

    // Register global trackers
    approot.registerTracker(BlazorIntegrator);
    approot.registerTracker(ServiceWorkerRegistration);

    // Debug support
    const debugAuth = React.lazy(() => import('./pages/DebugAuth'));
    approot.registerPage('/devstart', debugAuth, { layout: 'page' });

    // Authentication and user profile
    const signOutPage = React.lazy(() => import('./pages/SignOut'));
    approot.registerPage('/signout', signOutPage, { layout: 'page' });
    approot.registerPage('/signoutcallback', SignOutCallback, { layout: 'page' });
    approot.registerPage('/signincallback', SignInCallback, { layout: 'page' })
    const userMenuItem = React.lazy(() => import('./components/UserMenu'));
    const profilePage = React.lazy(() => import('./pages/Profile'));
    const userProfileExtension = React.lazy(() => import('./components/UserProfile'));
    const accountInfoExtension = React.lazy(() => import('./pages/AccountInfo'));
    approot.registerMenu('system-user', userMenuItem, { type: 'header', priority: 8 });
    approot.registerPage('/profile', profilePage);
    approot.registerExtension('profile-extension', userProfileExtension, {
        label: 'My profile'
    });
    approot.registerExtension('profile-extension', accountInfoExtension, {
        label: 'Account information and access'
    });

    // Settings
    approot.registerMenu('settings', SettingsMenu, { type: 'header', priority: 7 });

    // Settings -> System settings
    const settingsPage = React.lazy(() => import('./pages/SystemSettings'));
    approot.registerPage('/settings/:id?', settingsPage, { title: 'System Settings' });
    approot.registerExtension('settings-menu-extension', SystemSettingsMenu);

    // Settings -> User settings
    const userSettingsPage = React.lazy(() => import('./pages/UserSettings'));
    approot.registerPage('/usersettings/:id?', userSettingsPage, { title: 'User Settings' });
    approot.registerExtension('settings-menu-extension', UserSettingsMenu);
    approot.registerExtension('usersettings-extension', SettingsAccessibility, {
        label: 'Accessibility'
    });

    // Register system menus
    approot.registerMenu('system-home', HomeMenu);
    approot.registerExtension('settings-menu-extension', AboutMenu, { type: 'header' });
    let aboutPage = React.lazy(() => import('./pages/About'));
    approot.registerPage('/about', aboutPage);

    // Stuff that's in preview atm
    if (appsettings?.preview === true) {
        // Register search menu
        approot.registerMenu('system-search', SearchMenu, { type: 'header' });
    }
}